// modals
document.addEventListener("DOMContentLoaded", function () {

    // open
    document.querySelectorAll(`[open-modal]`).forEach(function (element) {
        element.addEventListener("click", function () {
            let id = this.getAttribute("open-modal");
            if (document.querySelector(`#modal-${id}`)) {
                document.querySelector(`#modal-${id}`).classList.add("active");
            }
        });
    });

    // close
    document.querySelectorAll(".modal").forEach(function (element) {
        element.addEventListener("click", function (e) {
            if (e.target === this) {
                this.classList.remove("active");
            }
        });
    });

    // close
    document.querySelectorAll(".modalExit").forEach(function (element) {
        element.addEventListener("click", function () {
            this.closest(".modal").classList.remove("active");
        });
    });

});

// pdp sticky atc
if (document.querySelector("#sticky")) {

    //atc
    document.querySelector("#stickyButton").addEventListener("click", function () {
        this.classList.add("loading");
        document.querySelector(".add-to-cart").click();
        setTimeout(() => {
            this.classList.remove("loading");
        }, 1000);
    });

    // scroll

    // details
    document.querySelector(".stickyNavLink[href='#details']").addEventListener("click", function (e) {
        e.preventDefault();
        window.scroll({
            behavior: "smooth",
            top: document.querySelectorAll(".tabs")[0].offsetTop
        });
    });

    // results
    document.querySelector(".stickyNavLink[href='#results']").addEventListener("click", function (e) {
        e.preventDefault();
        window.scroll({
            behavior: "smooth",
            top: document.querySelectorAll(".tabs")[1].offsetTop
        });
    });

    // reviews
    document.querySelector(".stickyNavLink[href='#reviews']").addEventListener("click", function (e) {
        e.preventDefault();
        window.scroll({
            behavior: "smooth",
            top: document.querySelector("#judgeme_product_reviews").offsetTop
        });
    });

    // faq
    document.querySelector(".stickyNavLink[href='#faq']").addEventListener("click", function (e) {
        e.preventDefault();
        window.scroll({
            behavior: "smooth",
            top: document.querySelector(".sf-collapsible").offsetTop
        });
    });
}

// GA event PDP
if (window.location.href.includes("/products/")) {
    document.querySelectorAll(".quantity-input__button").forEach(element => {
        element.addEventListener("click", function () {
            dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "quantity_change",
                quantitychange: this.getAttribute("name")
            });
        })
    })
}

/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// apply a discount code to the cart, keeping any codes already applied, and confirm it stuck
async function applyDiscountCode(code) {
    const matches = (currentCart) => currentCart.discount_codes.some((item) => {
        return item.code.toLowerCase() === code.toLowerCase() && item.applicable === true;
    });

    // combine existing applicable codes with the new one (Shopify expects a comma separated list)
    cart = await getCart();
    const codes = cart.discount_codes.filter(item => item.applicable).map(item => item.code);
    codes.push(code);
    cart = await updateCart({discount: codes.join(",")});

    // cart/update.js resolves before the discount engine settles, so re-fetch until the code shows as applicable
    for (let attempt = 0; attempt < 3 && !matches(cart); attempt++) {
        await sleep(300);
        cart = await getCart();
    }

    return matches(cart);
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
